module.exports = __webpack_public_path__ + "static/media/check-icon.b43ba942.png";